import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
Vue.use(Vuex)
const state = {
  meetingId: localStorage.getItem('meetingId')||0,
  currentHotel: {},
  currentRoom: {
    totalPrice: 0,
    roomList: []
  },
  isPc: false,
  userinfo:{},
  registerMobile: ''
}
const store = new Vuex.Store({
  mutations,
  actions,
  state
})

export default store
